import LegalLayout from "../components/LegalLayout";
import { useLang } from "../i18n/LanguageContext";

const H = ({ children }) => (
  <h2 className="font-heading text-xl sm:text-2xl font-bold text-[#0A0D1F] mb-3">{children}</h2>
);

export default function Impressum() {
  const { t } = useLang();
  const im = t.impressum;
  return (
    <LegalLayout title={im.title}>
      <section data-testid="impressum-anbieter">
        <H>{im.h_anbieter}</H>
        <p className="text-[#0A0D1F] font-medium">
          JA! Consulting &amp; Support
          <br />
          Jibumon Kannanthanathu
          <br />
          Schlegelstr. 3
          <br />
          42719 Solingen
          <br />
          Deutschland
        </p>
        <p className="mt-3">{im.legalForm}</p>
      </section>

      <section data-testid="impressum-vertreten">
        <H>{im.h_vertreten}</H>
        <p className="text-[#0A0D1F] font-medium">Jibumon Kannanthanathu</p>
      </section>

      <section data-testid="impressum-kontakt">
        <H>{im.h_kontakt}</H>
        <p>
          {im.phone}:{" "}
          <a href="tel:+4915773000078" className="text-[#1e2a6e] font-medium hover:text-[#4a90d9]">
            +49 1577 3000078
          </a>
          <br />
          {im.email}:{" "}
          <a href="mailto:info@jasupport.de" className="text-[#1e2a6e] font-medium hover:text-[#4a90d9]">
            info@jasupport.de
          </a>
        </p>
      </section>

      <section data-testid="impressum-verantwortlich">
        <H>{im.h_verantwortlich}</H>
        <p>
          Jibumon Kannanthanathu
          <br />
          JA! Consulting &amp; Support
          <br />
          Schlegelstr. 3, 42719 Solingen
        </p>
      </section>

      <section data-testid="impressum-streit">
        <H>{im.h_streit}</H>
        <p>{im.streit}</p>
      </section>

      <section data-testid="impressum-haftung">
        <H>{im.h_haftungInhalte}</H>
        <p>{im.haftungInhalte}</p>
        <H>{im.h_haftungLinks}</H>
        <p>{im.haftungLinks}</p>
        <H>{im.h_urheber}</H>
        <p>{im.urheber}</p>
      </section>
    </LegalLayout>
  );
}
